import {createMultiStyleConfigHelpers} from '@chakra-ui/react';
import type {SystemStyleObject} from '@chakra-ui/styled-system';
import {useMultiStyleConfig} from '@chakra-ui/system';

const parts = [`root`, `content`, `controlsOn`, `controlsOff`] as const;

const helpers = createMultiStyleConfigHelpers(parts);

export const editableFieldsTheme = helpers.defineMultiStyleConfig({
  baseStyle: helpers.definePartsStyle(props => ({
    root: {
      display: `flex`,
      alignItems: `start`,
      bgColor: `white`,
      px: `space-200`,
      py: `space-150`,
      border: `base`,
      borderColor: `stroke.primary`,
      borderRadius: `radius-100`,
      gap: `space-050`,
      '&:hover .editable-controls-off': {
        opacity: 1,
      },
    },
    content: {
      display: `flex`,
      alignSelf: `center`,
      flexGrow: 1,
      flexDirection: `column`,
      alignItems: `stretch`,
      gap: props.isEditing ? `space-050` : undefined,
    },
    controlsOn: {
      display: `flex`,
      gap: `space-100`,
      ml: `space-100`,
    },
    controlsOff: {
      display: `flex`,
      alignItems: `center`,
      justifyContent: `center`,
      minHeight: `2rem`, // 32px
      transitionDuration: `normal`,
      transitionProperty: `opacity`,
      opacity: 0,
      _focusWithin: {
        opacity: 1,
      },
    },
  })),
});

export const useEditableFieldsStyleConfig = (
  props?: Parameters<typeof useMultiStyleConfig>[1],
): Record<(typeof parts)[number], SystemStyleObject> => useMultiStyleConfig(`EditableFields`, props ?? {});
